interface IconProps {
  className?: string;
}

/** Checkmark glyph from the DubaiExpress product page mockup (guarantee list). */
const CheckIcon = ({ className }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    className={className}
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export default CheckIcon;
